/**
 * Mirror of the job model exposed by the gateway (`/api/jobs`).
 * Keep in sync with `batail-log-gateway/src/types/job.type.ts`.
 */

export enum JobType {
  DEBUG_PING = "debug:ping",
  EXPORT_EDB = "export:edb",
  EXPORT_XLSX = "export:xlsx",
  EXPORT_ORDERS = "export:orders",
  EXPORT_RECEPTIONS = "export:receptions",
  EXPORT_STOCK = "export:stock",
  IMPORT_BULK = "import:bulk",
}

export enum JobStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  COMPLETED = "completed",
  COMPLETED_WITH_WARNINGS = "completed_with_warnings",
  FAILED = "failed",
  CANCELLED = "cancelled",
}

export enum JobResultKind {
  FILE = "file",
  SUMMARY = "summary",
}

export interface JobProgress {
  percent: number;
  step?: string;
  message?: string;
}

export interface JobFileResult {
  kind: JobResultKind.FILE;
  fileName: string;
  mimeType: string;
  size: number;
}

export interface JobSummaryResult {
  kind: JobResultKind.SUMMARY;
  message?: string;
  counts?: Record<string, number>;
}

export type JobResult = JobFileResult | JobSummaryResult;

export interface JobRecord {
  id: string;
  type: JobType;
  label: string;
  status: JobStatus;
  ownerId: string;
  progress: JobProgress;
  warnings: string[];
  result?: JobResult;
  error?: { message: string; code?: string };
  attempt: number;
  createdAt: string;
  startedAt?: string;
  finishedAt?: string;
}

export const TERMINAL_JOB_STATUSES: JobStatus[] = [
  JobStatus.COMPLETED,
  JobStatus.COMPLETED_WITH_WARNINGS,
  JobStatus.FAILED,
  JobStatus.CANCELLED,
];

export const isJobFinished = (job: JobRecord) =>
  TERMINAL_JOB_STATUSES.includes(job.status);

export const isJobSuccessful = (job: JobRecord) =>
  job.status === JobStatus.COMPLETED ||
  job.status === JobStatus.COMPLETED_WITH_WARNINGS;

export const hasDownloadableFile = (job: JobRecord) =>
  isJobSuccessful(job) && job.result?.kind === JobResultKind.FILE;
